import {
  GET_BANNERS,
  ADD_BANNER,
  UPDATE_BANNER_STATUS,
  DELETE_BANNER,
  GET_BANNER_DETAILS,
  UPDATE_BANNER,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const bannersSlice = createCrudSlice({
  name: "roles",
  urls: {
    getList: GET_BANNERS,
    add: ADD_BANNER,
    updateStatus: UPDATE_BANNER_STATUS,
    delete: DELETE_BANNER,
    update: UPDATE_BANNER,
    getDetails: GET_BANNER_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
});

// Export actions
export const { setFilter, resetFilters } = bannersSlice.actions;

// Export thunks
export const {
  getList: getBanners,
  add: addBanner,
  update: updateBanner,
  delete: deleteBanner,
  updateStatus: updateBannerStatus,
  getDetails: getBannerDetails,
} = bannersSlice.thunks;

// Export reducer
export default bannersSlice.reducer;
